import { css } from '@emotion/react';
import type { TypographyProps } from '@mui/joy';
import { styled, Typography } from '@mui/joy';

const StyledTypograph = styled(Typography)(
  ({ theme }) => css`
    font-family: ${theme.vars.fontFamily.body};
  `,
);

export function IllustrationModalTitle(props: TypographyProps) {
  return <StyledTypograph level="h4" {...props} />;
}
